import type { Enquiry } from '@motorway/motorway-handshake-components/types';

export const addImgixParams = (url: string) => {
  if (!url) {
    return null;
  }

  const rawImage = new URL(url);

  if (rawImage.searchParams.get('s') || rawImage.searchParams.get('X-Amz-Security-Token')) {
    return url;
  }

  rawImage.searchParams.set('w', globalThis.window.innerWidth.toString());
  rawImage.searchParams.set('auto', 'compress,format');
  rawImage.searchParams.set('dpr', globalThis.window.devicePixelRatio.toString() || '1');

  return rawImage.toString();
};

export const getVehicleImage = (
  vehicleImages: Enquiry['enquiry']['vehicleImages'] = [],
) => addImgixParams(
  (vehicleImages.find(({ kind }) => kind === 'exterior_front_driver') ?? vehicleImages[0])?.url,
);

export const formatCurrency = (value = 0) => {
  const fractionDigits = Number.isInteger(value) ? 0 : 2;

  return value.toLocaleString('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};
